module.exports = __webpack_public_path__ + "img/zhipinban4.69c20c6e.jpg";